import React from 'react';
import {connect} from 'react-redux';
import {
  List,
  Divider,
  ListItem,
  FontIcon,
} from 'react-md';

import {logoutRequest} from './../../../store/reducers/user';

import NavLink from './../../atoms/navLink';

const nav = [
  {label: 'Inicio', icon: 'home', to: '/', exact: true},
  {label: 'Usuarios', icon: 'people', to: '/users'},
  {label: 'Reportes', icon: 'assignment', to: '/reports'},
  {label: 'Auditoria', icon: 'assignment_turned_in', to: '/audit'},
  {label: 'Configuración', icon: 'settings', to: '/settings'},
];

const NavList = props => {
  const doLogout = () => {
    return props.logoutRequest();
  };

  console.log(props);

  return (
    <List style={styles.list}>
      {nav.map((item, index) => (
        <NavLink
          key={index}
          label={item.label}
          icon={item.icon}
          to={item.to}
          exact={item.exact}
        />
      ))}
      <Divider/>
      <NavLink
        key={999}
        label="Mi perfil"
        icon="person"
        to="/profile"
      />
      <Divider/>
      <ListItem
        primaryText="Cerrar Sessión"
        leftIcon={<FontIcon>exit_to_app</FontIcon>}
        onClick={() => doLogout()}
      />
    </List>
  );
};

const styles = {
  list: {
    backgroundColor: 'transparent',
    position: 'sticky',
    top: '6rem',
  }
};

const mapDispatchToProps = dispatch => ({
  logoutRequest: () => dispatch(logoutRequest())
});

export default connect(null, mapDispatchToProps)(NavList);



// WEBPACK FOOTER //
// ./src/components/organisms/lists/navList.js